"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StoryBlokPage = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _MuiCircularProgress = _interopRequireDefault(require("../MuiCircularProgress/MuiCircularProgress"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _Blok = _interopRequireDefault(require("./components/Blok/Blok"));

var _MuiTransitions = _interopRequireDefault(require("../MuiTransitions/MuiTransitions"));

var _StoryBlokPageModule = _interopRequireDefault(require("./StoryBlokPage.module.scss"));

var _jsonSbAsset = _interopRequireDefault(require("../../utils/json-sb-asset"));

var _customComponents = require("../../utils/customComponents");

var _PageGrid = _interopRequireDefault(require("../PageGrid/PageGrid"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var StoryBlokPage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(StoryBlokPage, _Component);

  var _super = _createSuper(StoryBlokPage);

  function StoryBlokPage() {
    var _this;

    (0, _classCallCheck2.default)(this, StoryBlokPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      story: [],
      loading: true,
      error: '',
      muiTheme: {}
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "components", {
      Blok: _Blok.default,
      MuiTransitions: _MuiTransitions.default,
      PageGrid: _PageGrid.default
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "appendStoryblokBridgeScript", function (accessToken) {
      if (process.env.REACT_APP_ENV !== 'production') {
        var existingScript = document.getElementById('storyblokBridge');

        if (!existingScript) {
          var script = document.createElement('script');
          script.src = "//app.storyblok.com/f/storyblok-latest.js?t=".concat(accessToken);
          script.id = 'storyblokBridge';
          document.body.appendChild(script);

          script.onload = function () {
            // Initialize the Storyblok JS Bridge
            window.storyblok.init({
              accessToken: accessToken
            }); // Ping the Visual Editor and enter Editmode manually

            window.storyblok.pingEditor(function () {
              if (window.storyblok.inEditor) {
                window.storyblok.enterEditmode();
                window.storyblok.on(['change', 'saved'], function () {
                  window.location.reload(true);
                });
              }
            });
          };
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setpropTheme", function (theme) {
      var muiTheme = (0, _styles.createMuiTheme)(theme);

      _this.setState({
        muiTheme: muiTheme
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getUrlTheme", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(urlTheme, theme) {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _jsonSbAsset.default)(urlTheme);

              case 3:
                res = _context.sent;
                return _context.abrupt("return", (0, _styles.createMuiTheme)(res));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.warn("issue getting theme from ".concat(urlTheme, " using to ").concat(theme ? 'theme passed by props' : 'mui default theme', "  "));
                return _context.abrupt("return", (0, _styles.createMuiTheme)(theme));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pickTheme", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(urlTheme, theme) {
        var muiTheme;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(urlTheme && !_this.props.useObjectTheme)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return _this.getUrlTheme(urlTheme);

              case 3:
                muiTheme = _context2.sent;
                _context2.next = 7;
                break;

              case 6:
                muiTheme = (0, _styles.createMuiTheme)(theme);

              case 7:
                return _context2.abrupt("return", muiTheme);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPage", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var route, story, muiTheme;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              route = window.location.pathname === '/' ? _this.props.dynamicSlug : window.location.pathname.slice(1);
              _context3.next = 4;
              return _Storyblok.default.get(route, _this.props.accessToken, _this.props.version);

            case 4:
              story = _context3.sent;
              _context3.next = 7;
              return _this.pickTheme(story[1], _this.props.theme);

            case 7:
              muiTheme = _context3.sent;

              _this.setState({
                muiTheme: muiTheme
              });

              _this.setStory(story[0]);

              _context3.next = 16;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);
              _context3.next = 16;
              return _this.pageNotFound();

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pageNotFound", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var story;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _Storyblok.default.get('page-not-found', _this.props.accessToken, _this.props.version);

            case 3:
              story = _context4.sent;

              _this.setStory(story);

              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              _this.setState({
                error: 'Unable to fetch page content please refresh and try again or check to make sure you are at the right url'
              });

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setStory", function (story) {
      // scroll to top of page when setting a new story
      document.body.scrollTop = 0; // For Safari

      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

      _this.setState({
        loading: false,
        story: story
      });
    });
    return _this;
  }

  (0, _createClass2.default)(StoryBlokPage, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.appendStoryblokBridgeScript(this.props.accessToken);
                _context5.next = 3;
                return this.getPage();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.theme !== this.props.theme && this.props.useObjectTheme) {
        this.setpropTheme(this.props.theme);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        direction: "row",
        justify: "center",
        alignItems: "center"
      }, this.state.loading && !this.state.error && /*#__PURE__*/_react.default.createElement(_MuiCircularProgress.default, null), this.state.error && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'red'
        }
      }, this.state.error), !this.state.loading && /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
        theme: this.state.muiTheme
      }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: _StoryBlokPageModule.default.container
      }, this.state.story && this.state.story.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index
        }, (0, _customComponents.renderComponents)(_this2.components, item, index));
      }))));
    }
  }]);
  return StoryBlokPage;
}(_react.Component);

exports.StoryBlokPage = StoryBlokPage;
var _default = StoryBlokPage;
exports.default = _default;
StoryBlokPage.propTypes = {
  dynamicSlug: _propTypes.default.string,
  version: _propTypes.default.string.isRequired,

  /** acess key from storyblok you can make them in storyblok settings */
  accessToken: _propTypes.default.string.isRequired,

  /** theme for mui */
  theme: _propTypes.default.shape(),

  /**
   * override url theme to edit in mui-theme tool
   */
  useObjectTheme: _propTypes.default.bool
};
StoryBlokPage.defaultProps = {
  theme: {},
  useObjectTheme: false,
  dynamicSlug: 'page-welcome'
};